import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import SyncAltOutlinedIcon from 'components/material-symbol/icons/SyncAlt'
import Button from '@material-ui/core/Button'
import AddOutlinedIcon from 'components/material-symbol/icons/Add'
import { useStyles } from './styles'
import NewSponsorshipModal from './new-sponsorship-modal'

const NoSponsorships = ({ facilities, refetch }) => {
  const styles = useStyles()

  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={10}>
      <Box maxWidth="480px" textAlign="center">
        <IconButton className={styles.iconButton}>
          <SyncAltOutlinedIcon fontSize="large" color="primary" />
        </IconButton>
        <Typography variant="h6" className={styles.heading}>
          No Sponsorships
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: '28px' }}
        >
          You do not have any PGA Coach sponsorships. Add a new sponsorship to
          allow a non-PGA of America member at your facility to use the PGA
          Coach platform. Please note this is not access to other PGA of America
          programming.
        </Typography>
        <NewSponsorshipModal
          trigger={
            <Button
              startIcon={<AddOutlinedIcon />}
              variant="contained"
              color="primary"
            >
              New Sponsorship
            </Button>
          }
          onAdd={() => {
            refetch()
          }}
          facilities={facilities}
        />
      </Box>
    </Box>
  )
}

export default NoSponsorships
